export const socialProfiles = {
  codingProfile: [
    {
      name: "GeeksforGeeks",
      url: "https://auth.geeksforgeeks.org/user/bhaskaracharjee/profile",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/geeks-for-geeks.svg",
      username: "@BhaskarAcharjee",
    },
    {
      name: "LeetCode",
      url: "https://www.leetcode.com/bhaskaracharjee",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/leet-code.svg",
      username: "@BhaskarAcharjee",
    },
    {
      name: "Codeforces",
      url: "https://codeforces.com/profile/bha_s_kar",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/codeforces.svg",
      username: "@bha_s_kar",
    },
    {
      name: "Codechef",
      url: "https://www.codechef.com/users/bha_s_kar",
      imgSrc: "https://avatars.githubusercontent.com/u/11960354?v=4",
      username: "@bha_s_kar",
    },
    {
      name: "GitHub",
      url: "https://github.com/BhaskarAcharjee",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/github.svg",
      username: "@BhaskarAcharjee",
    },
  ],
  researchProfile: [
    {
      name: "ResearchGate",
      url: "https://www.researchgate.net/profile/Bhaskar-Acharjee",
      imgSrc:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/ResearchGate_icon_SVG.svg/2048px-ResearchGate_icon_SVG.svg.png",
      username: "@Bhaskar_Acharjee",
    },
    {
      name: "Google Scholar",
      url: "https://scholar.google.com/citations?user=ZkmURxEAAAAJ&hl=en&authuser=3",
      imgSrc:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Google_Scholar_logo.svg/2048px-Google_Scholar_logo.svg.png",
      username: "@BhaskarAcharjee",
    },
    {
      name: "ORCID",
      url: "https://orcid.org/0000-0002-3629-4018",
      imgSrc:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/ORCID_iD.svg/2048px-ORCID_iD.svg.png",
      username: "@BhaskarAcharjee",
    },
  ],
  socialProfile: [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/bhaskar-acharjee/",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/linked-in-alt.svg",
      username: "@BhaskarAcharjee",
    },
    {
      name: "Twitter",
      url: "https://twitter.com/_bha_s_kar_",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/twitter.svg",
      username: "@_bha_s_kar_",
    },
    {
      name: "Instagram",
      url: "https://instagram.com/bhassssskar",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/instagram.svg",
      username: "@bhassssskar",
    },
    {
      name: "YouTube",
      url: "https://youtube.com/@CorvasBhaskar",
      imgSrc:
        "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/youtube.svg",
      username: "@CorvasBhaskar",
    },
  ],
  otherProfile: [
    {
      name: "Portfolio v1",
      url: "https://bhaskaracharjee.github.io/Portfolio-Website/",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/1022/1022533.png",
      username: "@BhaskarAcharjee",
    },
    {
      name: "Portfolio v2",
      url: "https://bhaskaracharjee.github.io/Dev-Portfolio-Website/",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/1022/1022533.png",
      username: "@BhaskarAcharjee",
    },
  ],
};
